import DraggableObjectTarget from 'ember-drag-drop/components/draggable-object-target';

export default DraggableObjectTarget;
